import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "./__root.js";

export const rescheduleBookingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/reschedule/$token",
  component: lazyRouteComponent(
    () => import("./reschedule-booking.page.js"),
    "RescheduleBookingPage",
  ),
});
